//#region Imports
import React, { useEffect } from "react";
import { Outlet } from "react-router";

import { useDispatch } from "react-redux";
import { initUsers } from "../../../store/slicers/page specific slicers/Admin Panel Slicer";
import { useGetAllUsersQuery } from "../../../store/api/auth api";

import { BASE_REFETCH_TIME_MS } from "../../../../constants/global";
//#endregion

/**
 * Wrapper for admin panel related pages to get user information regardless of the first rendered page.
 * @returns {JSX.Element}
 */
const AdminPanelWrapper = () => {
  //#region Hooks
  const dispatch = useDispatch();
  const { data, refetch, isUninitialized } = useGetAllUsersQuery();
  //#endregion

  //#region Effects
  // Set refetch every 5 seconds
  useEffect(() => {
    if (isUninitialized) return;

    const interval = setInterval(() => {
      refetch();
    }, BASE_REFETCH_TIME_MS);

    return () => clearInterval(interval);
  }, [refetch, isUninitialized]);

  useEffect(() => {
    dispatch(initUsers(data));
  }, [data]);
  //#endregion
  return <Outlet />;
};

export default AdminPanelWrapper;
